import { cva } from 'class-variance-authority';

export const cvaAddingCard = cva(
  [
    'AddingCardStyles-cvaAddingCard',
    'flex justify-between items-center',
    'py-1.4',
    'cursor-pointer',
    'relative',
  ],
  {
    variants: {
      type: {
        primary: [''],
        secondary: [
          'bg-[#373541] rounded-[0.8rem] p-1.6 not-last:mb-0.8 [&>span]:text-[#7C7B83] [&>span]:text-center [&>span]:text-[1.4rem] [&>span]:w-full [&>span]:font-semibold',
        ],
      },
    },
  }
);

export const cvaAddingCardText = cva([
  'AddingCardStyles-cvaAddingCard',
  'flex justify-between items-center',
  'gap-1.2',
  'text-m-sb ',
]);
